import { UnitOfMeasureEnum } from "../../../api/Representation";
import { TenantFeeCalculationMethodEnum } from "../../tenants/api/Representation";
import VehicleHirePaymentMethod from "../../../enums/VehicleHirePaymentMethod";
import { LoadRateCalcMethodEnum, VehicleHirePaymentMethodEnum } from "../../vehicleHires/api/Representation";
import { AddressTransformer } from "../../../../../swzutils/ConsignmentUtil";
import { MarketplaceProductSaleTypeEnum } from "../../marketplace/api/Representation";
export var SalesOrderStatusEnum;
(function (SalesOrderStatusEnum) {
    SalesOrderStatusEnum["QUOTE"] = "QUOTE";
    SalesOrderStatusEnum["APPROVED"] = "APPROVED";
    SalesOrderStatusEnum["REJECTED"] = "REJECTED";
    SalesOrderStatusEnum["ACCEPTED"] = "ACCEPTED";
    SalesOrderStatusEnum["DISPATCHED"] = "DISPATCHED";
    SalesOrderStatusEnum["CANCELLED"] = "CANCELLED";
    SalesOrderStatusEnum["COMPLETED"] = "COMPLETED";
})(SalesOrderStatusEnum || (SalesOrderStatusEnum = {}));
export var CustomerProjectStageEnum;
(function (CustomerProjectStageEnum) {
    CustomerProjectStageEnum["LIVE"] = "LIVE";
    CustomerProjectStageEnum["TENDER"] = "TENDER";
    CustomerProjectStageEnum["AWARDED"] = "AWARDED";
    CustomerProjectStageEnum["RATES_ONLY"] = "RATES_ONLY";
    CustomerProjectStageEnum["ORDER"] = "ORDER";
    CustomerProjectStageEnum["PRE_ORDER"] = "PRE_ORDER";
    CustomerProjectStageEnum["DIRECT"] = "DIRECT";
    CustomerProjectStageEnum["MARKETPLACE"] = "MARKETPLACE";
})(CustomerProjectStageEnum || (CustomerProjectStageEnum = {}));
export var FulfillmentMethodEnum;
(function (FulfillmentMethodEnum) {
    FulfillmentMethodEnum["PICKUP"] = "PICKUP";
    FulfillmentMethodEnum["DELIVER"] = "DELIVER";
    FulfillmentMethodEnum["DIRECT"] = "DIRECT";
})(FulfillmentMethodEnum || (FulfillmentMethodEnum = {}));
export var SalesOrderItemInclusionsEnum;
(function (SalesOrderItemInclusionsEnum) {
    SalesOrderItemInclusionsEnum["TENANT_CARTAGE_ONLY"] = "TENANT_CARTAGE_ONLY";
    SalesOrderItemInclusionsEnum["TENANT_CARTAGE_AND_PRODUCT"] = "TENANT_CARTAGE_AND_PRODUCT";
    SalesOrderItemInclusionsEnum["PRODUCT_ONLY"] = "PRODUCT_ONLY";
    SalesOrderItemInclusionsEnum["TENANT_PRODUCT_ONLY"] = "TENANT_PRODUCT_ONLY";
    SalesOrderItemInclusionsEnum["MARKETPLACE_PRODUCT_AND_CARTAGE"] = "MARKETPLACE_PRODUCT_AND_CARTAGE";
    SalesOrderItemInclusionsEnum["MARKETPLACE_PRODUCT_ONLY"] = "MARKETPLACE_PRODUCT_ONLY";
    SalesOrderItemInclusionsEnum["MARKETPLACE_CARTAGE_AND_DISPOSAL"] = "MARKETPLACE_CARTAGE_AND_DISPOSAL";
    SalesOrderItemInclusionsEnum["MARKETPLACE_DISPOSAL_ONLY"] = "MARKETPLACE_DISPOSAL_ONLY";
    SalesOrderItemInclusionsEnum["MARKETPLACE_HIRE"] = "MARKETPLACE_HIRE";
})(SalesOrderItemInclusionsEnum || (SalesOrderItemInclusionsEnum = {}));
export var ProductPricingMethodEnum;
(function (ProductPricingMethodEnum) {
    ProductPricingMethodEnum["COST_PLUS_MARKUP"] = "COST_PLUS_MARKUP";
    ProductPricingMethodEnum["MARKET_PRICE_PLUS_MARKUP"] = "MARKET_PRICE_PLUS_MARKUP";
    ProductPricingMethodEnum["RETAIL_PRICE_LIST"] = "RETAIL_PRICE_LIST";
})(ProductPricingMethodEnum || (ProductPricingMethodEnum = {}));
export var FeeType;
(function (FeeType) {
    FeeType["PER_UOM"] = "PER_UOM";
    FeeType["ONCE_OFF"] = "ONCE_OFF";
})(FeeType || (FeeType = {}));
export var AccountsTypeEnum;
(function (AccountsTypeEnum) {
    AccountsTypeEnum["RECEIVABLE"] = "RECEIVABLE";
    AccountsTypeEnum["PAYABLE"] = "PAYABLE";
})(AccountsTypeEnum || (AccountsTypeEnum = {}));
export var MarketplaceSelfHaulActionImageKindEnum;
(function (MarketplaceSelfHaulActionImageKindEnum) {
    MarketplaceSelfHaulActionImageKindEnum["DOCKET"] = "DOCKET";
    MarketplaceSelfHaulActionImageKindEnum["PHOTO"] = "PHOTO";
})(MarketplaceSelfHaulActionImageKindEnum || (MarketplaceSelfHaulActionImageKindEnum = {}));
export class DeliveryAddressTransformer {
    static responseToWaypoint(response) {
        if (!response) {
            return undefined;
        }
        return {
            companyName: response.companyName,
            contactName: response.contactName,
            contactTelephone: response.contactTelephone,
            contactEmail: response.contactEmailCsv,
            uhfChannelOffice: response.uhfChannelOffice,
            uhfChannelLoader: response.uhfChannelLoader,
            address: response.address || AddressTransformer.emptyAddressResponse(),
            sourcedSenderReceiverId: response.sourcedSenderReceiver?.id
        };
    }
    static fromResponse(response) {
        return {
            companyName: response.companyName,
            contactName: response.contactName,
            contactTelephone: response.contactTelephone,
            contactEmailCsv: response.contactEmailCsv,
            uhfChannelOffice: response.uhfChannelOffice,
            uhfChannelLoader: response.uhfChannelLoader,
            address: AddressTransformer.fromResponse(response.address),
            sourcedSenderReceiverId: response.sourcedSenderReceiver?.id,
            deliveryNotes: response.deliveryNotes,
        };
    }
}
export class SalesOrderItemUpdateRequestTransformer {
    static fromResponse(response) {
        return {
            inclusions: response.inclusions,
            productPricingMethod: response.productPricingMethod,
            fulfillmentMethod: response.fulfillmentMethod,
            includeOnCustomerQuote: response.includeOnCustomerQuote,
            productId: response.product?.id,
            productNotes: response.productNotes,
            marketplaceProductId: response.srMarketplaceProduct?.marketplaceProduct.id,
            srMarketplaceProductId: response.srMarketplaceProduct?.id,
            unitOfMeasure: response.unitOfMeasure,
            quantity: response.quantity,
            preferredVehicleTypeId: response.preferredVehicleType?.id,
            warehouseSenderReceiverId: response.warehouseSenderReceiver?.id,
            deliveryAddress: response.deliveryAddress && DeliveryAddressTransformer.fromResponse(response.deliveryAddress),
            receiverRef: response.receiverRef,
            nominatedTravelSeconds: response.nominatedTravelSeconds,
            loadingMinutes: response.loadingMinutes,
            unloadingMinutes: response.unloadingMinutes,
            payAsReturn: response.payAsReturn,
            cartageMarkupPercent: response.cartageMarkupPercent,
            nominatedCartageCostPerUomExTax: response.nominatedCartageCostPerUomExTax,
            productMarkupPercent: response.productMarkupPercent,
            nominatedProductCostPerUomExTax: response.nominatedProductCostPerUomExTax,
            nominatedMarketplaceProductAdminFeePercent: response.nominatedMarketplaceProductAdminFeePercent,
            fuelLevyNominatedPercent: response.fuelLevyNominatedPercent,
            rebateAmountPerUomExTax: response.rebateAmountPerUomExTax
        };
    }
}
